import { SubAccountInterface } from 'modules/subaccounts/types/sub-account-interface'
import { UserInterface } from 'shared/types/user-interface'

export const hasSubAccounts = (
  user?: UserInterface,
): user is UserInterface & {
  subaccounts: SubAccountInterface[]
} => {
  return Boolean(user && Array.isArray(user.subaccounts) && user.subaccounts.length > 0)
}
